/**
 * The automatic copy of the portal page the Olio extension attaches on "Send to Olio"
 * (OLIO-3584). It stays on the referral and goes through document processing, but the
 * referral's file lists leave it out (OLIO-3591). It's marked by this document type, which
 * the api validates (`Attachment::DOCUMENT_TYPES`). It's deliberately not one of
 * `DocumentTypes`, so the document-type menu never offers it to users.
 */
export const PORTAL_PAGE_COPY_DOC_TYPE = 'Portal Page Copy';

export function isPortalPageCopy(attachment: { docType?: string | null } | null | undefined): boolean {
  return attachment?.docType === PORTAL_PAGE_COPY_DOC_TYPE;
}

/**
 * The entries that aren't a page copy. An entry's own docType decides when it has one;
 * otherwise its id is looked up among `known` (e.g. the workflow's attachments), because
 * the attachments value carries only `{id, filename}`.
 */
export function withoutPortalPageCopies<T extends { id: string; docType?: string | null }>(
  entries: T[],
  known: { id: string; docType?: string | null }[] = []
): T[] {
  const pageCopyIds = new Set(known.filter(isPortalPageCopy).map((attachment) => attachment.id));
  return entries.filter((entry) => !isPortalPageCopy(entry) && !pageCopyIds.has(entry.id));
}
